export default {
  data() {
    return { year: new Date().getFullYear() };
  },
  on: {
    pageInit() {
      const mobileInput = document.getElementById('mobile');
      const dialCodeInput = document.getElementById('regDialCode');
      const dialCode = document.getElementById('dialCode');
      if (mobileInput && window.intlTelInput) {
        const iti = window.intlTelInput(mobileInput, {
          initialCountry: 'auto',
          geoIpLookup: function (callback) {
            fetch('https://ipapi.co/json/').then(function (res) {
              return res.json();
            }).then(function (data) {
              callback(data.country_code);
              var countrySelect = document.getElementById('country');
              if (countrySelect && data.country_code) {
                countrySelect.value = data.country_code.toUpperCase();
              }
            }).catch(function () {
              callback('in');
            });
          },
          separateDialCode: true,
          preferredCountries: [
            'in',
            'bd',
            'us',
            'gb',
            'ae',
            'sg'
          ],
          useFullscreenPopup: false
        });
        const syncDialCode = () => {
          const data = iti.getSelectedCountryData();
          if (dialCodeInput)
            dialCodeInput.value = (data.iso2 || 'in').toUpperCase();
          if (dialCode)
            dialCode.value = '+' + (data.dialCode || '+91');
        };
        mobileInput.addEventListener('countrychange', syncDialCode);
        syncDialCode();
        window._rp_iti = iti;
      }
      const dobInput = document.getElementById('dob');
      if (dobInput) {
        const maxDOB = new Date();
        maxDOB.setFullYear(maxDOB.getFullYear() - 5);
        this.$app.calendar.create({
          inputEl: dobInput,
          openIn: 'popup',
          dateFormat: 'dd/mm/yyyy',
          closeOnSelect: true,
          routableModals: false,
          toolbarCloseText: 'Done',
          monthNames: [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
          ],
          monthNamesShort: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec'
          ],
          on: {
            change: function (cal, val) {
              dobInput.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
        });
      }
      const toggle = document.getElementById('regTogglePassword');
      const pwInput = document.getElementById('password');
      if (toggle && pwInput) {
        toggle.addEventListener('click', () => {
          const isPassword = pwInput.type === 'password';
          pwInput.type = isPassword ? 'text' : 'password';
          toggle.querySelector('i').textContent = isPassword ? 'eye_slash' : 'eye';
        });
      }
    }
  },
  id: '52075d57d7',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\n  <div class="page rp" data-name="register">\n    <div class="page-content rp__content">\n\n      <div class="rp__bg-grid" aria-hidden="true"></div>\n      <div class="rp__bg-glow" aria-hidden="true"></div>\n      <div class="rp__bg-glow2" aria-hidden="true"></div>\n\n      <!-- Back -->\n      <a href="#" class="rp__back link back" aria-label="Go back">\n        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="15 18 9 12 15 6"/></svg>\n      </a>\n\n      <!-- Header -->\n      <header class="rp__header">\n        <div class="rp__logo-halo"></div>\n        <img src="assets/icons/icon_wide.png" alt="DigiMExpress" class="rp__logo">\n        <div class="rp__brand-rule">\n          <span></span><span class="rp__brand-diamond">\u25C6</span><span></span>\n        </div>\n        <p class="rp__brand-tag">PREMIUM INVESTMENT PLATFORM</p>\n      </header>\n\n      <!-- Card -->\n      <div class="rp__card">\n        <div class="rp__card-accent"></div>\n        <div class="rp__card-body">\n\n          <div class="rp__card-heading">\n            <h1 class="rp__title">Create Account</h1>\n            <p class="rp__subtitle">Join the global gold investment platform</p>\n          </div>\n\n          <form name="userSignup" id="userSignup" action="" method="POST" novalidate>\n\n            <!-- Full Name -->\n            <div class="rp__field item-input">\n              <label class="rp__label" for="name">\n                <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#C9A969" stroke-width="2.5"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>\n                Full Name\n              </label>\n              <div class="rp__input-row">\n                <input type="text" name="name" id="name" placeholder="Enter your full name" pattern="^[a-zA-Z][a-zA-Z ]{1,49}$" maxlength="50" minlength="2"\n                  validate required class="rp__input" style="padding:0 14px;"\n                  data-error-message="Please enter your full name" />\n              </div>\n              <div class="item-input-error-message">Please enter your full name</div>\n            </div>\n\n            <!-- Mobile -->\n            <div class="rp__field item-input">\n              <label class="rp__label" for="mobile">\n                <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#C9A969" stroke-width="2.5"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 1.27h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.77a16 16 0 0 0 6.29 6.29l.88-.88a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>\n                Mobile Number\n              </label>\n              <div class="rp__phone-row">\n                <input type="hidden" name="countryCode" id="regDialCode" value="IN" />\n                <input type="hidden" name="dialCode" id="dialCode" value="+91" />\n                <input type="tel" name="mobile" id="mobile"\n                  placeholder="Enter mobile number"\n                  maxlength="15" minlength="10" validate required\n                  data-error-message="Please enter your mobile number"\n                  class="rp__input rp__iti-input" />\n              </div>\n              <div class="item-input-error-message">Please enter your mobile number</div>\n            </div>\n\n            <!-- Email -->\n            <div class="rp__field item-input">\n              <label class="rp__label" for="emailid">\n                <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#C9A969" stroke-width="2.5"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>\n                Email Address\n              </label>\n              <div class="rp__input-row">\n                <input type="email" name="emailid" id="emailid" placeholder="Enter your email"\n                  validate required class="rp__input" style="padding:0 14px;"\n                  data-error-message="Please enter a valid email address" />\n              </div>\n              <div class="item-input-error-message">Please enter a valid email address</div>\n            </div>\n\n            <!-- \u2500\u2500 Address (removed \u2014 no longer collected at registration) \u2500\u2500\n            <div class="rp__field item-input">\n              <label class="rp__label" for="address">\n                <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#C9A969" stroke-width="2.5"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>\n                Full Address\n              </label>\n              <div class="rp__input-row" style="position:relative;">\n                <input type="text" name="address" id="address" placeholder="Enter your full address"\n                  validate required class="rp__input" style="padding:0 44px 0 14px;"\n                  data-error-message="Please enter your full address" />\n                <button type="button" class="rp__loc-btn" id="getLocation" title="Use current location">\n                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="3"/><path d="M12 1v4M12 19v4M1 12h4M19 12h4"/><circle cx="12" cy="12" r="9"/></svg>\n                </button>\n              </div>\n              <div class="item-input-error-message">Please enter your full address</div>\n            </div>\n            \u2500\u2500 End address \u2500\u2500 -->\n\n            <!-- Gender + DOB (two column) -->\n            <div class="rp__row-2col">\n              <div class="rp__field">\n                <label class="rp__label" for="gender">\n                  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#C9A969" stroke-width="2.5"><circle cx="12" cy="7" r="4"/><path d="M5.5 21a6.5 6.5 0 0 1 13 0"/></svg>\n                  Gender\n                </label>\n                <div class="rp__select-row">\n                  <select name="gender" id="gender" class="rp__select">\n                    <option value="male" selected>Male</option>\n                    <option value="female">Female</option>\n                    <option value="others">Others</option>\n                  </select>\n                  <svg class="rp__select-arrow" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#C9A969" stroke-width="2.5"><polyline points="6 9 12 15 18 9"/></svg>\n                </div>\n              </div>\n\n              <div class="rp__field item-input">\n                <label class="rp__label" for="dob">\n                  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#C9A969" stroke-width="2.5"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>\n                  Date of Birth\n                </label>\n                <div class="rp__input-row" style="position:relative;">\n                  <input type="text" name="dob" id="dob" validate required readonly\n                    class="rp__input rp__input--date"\n                    placeholder="Tap to select" style="padding:0 38px 0 14px; cursor:pointer;"\n                    data-error-message="Please select your date of birth" />\n                  <span class="rp__cal-ico" aria-hidden="true">\n                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#C9A969" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>\n                  </span>\n                </div>\n                <div class="item-input-error-message">Please select your date of birth</div>\n              </div>\n            </div>\n\n            <!-- Password -->\n            <div class="rp__field item-input">\n              <label class="rp__label" for="password">\n                <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#C9A969" stroke-width="2.5"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>\n                Set Password\n              </label>\n              <div class="rp__input-row" style="position:relative;">\n                <input type="password" name="password" id="password"\n                  placeholder="Min. 6 characters"\n                  minlength="6" validate required\n                  data-error-message="Password must be at least 6 characters"\n                  class="rp__password-input" style="padding-right:44px; padding-left:14px;" />\n                <button type="button" class="rp__eye-btn" id="regTogglePassword" tabindex="0" aria-label="Toggle password"\n                  style="position:absolute;right:8px;top:50%;transform:translateY(-50%);height:28px;width:36px;display:flex;align-items:center;justify-content:center;background:transparent;border:none;">\n                  <i class="f7-icons" aria-hidden="true">eye</i>\n                </button>\n              </div>\n              <div class="item-input-error-message">Password must be at least 6 characters</div>\n            </div>\n\n            <!-- Referral -->\n            <div class="rp__field item-input">\n              <label class="rp__label" for="referral">\n                <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#C9A969" stroke-width="2.5"><polyline points="16 18 22 12 16 6"/><polyline points="8 6 2 12 8 18"/></svg>\n                Referral Code\n              </label>\n              <div class="rp__input-row">\n                <input type="text" name="referral" id="referral" placeholder="Referral code"\n                  value="860F7321EF" required validate class="rp__input" style="padding:0 14px;"\n                  data-error-message="Referral code is required" />\n              </div>\n              <div class="item-input-error-message">Referral code is required</div>\n            </div>\n\n            <!-- Submit -->\n            <button type="button" class="rp__btn-primary btnSignup">\n              <span>Complete Registration</span>\n              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>\n            </button>\n\n          </form>\n\n          <div class="rp__divider">\n            <span></span>\n            <p>Already have an account?</p>\n            <span></span>\n          </div>\n\n          <a href="/login/" class="rp__btn-secondary">Sign In</a>\n\n        </div>\n      </div>\n\n      <footer class="rp__legal">\n        <p>By registering you agree to our <a href="https://digitalmoneyexpress.com/terms-of-service/" target="_blank" class="external link">Terms of Service</a> &amp; <a href="https://digitalmoneyexpress.com/privacy-policy/" target="_blank" class="external link">Privacy Policy</a></p>\n        <p class="rp__legal-copy">&copy; ';
      r += c(ctx_1.year, ctx_1);
      r += ' Digi Money Express. All rights reserved.</p>\n      </footer>\n\n    </div>\n  </div>\n';
      return r;
    }(this);
  },
  style: `
/* ── Reset ── */
.rp *, .rp *::before, .rp *::after { box-sizing: border-box; margin: 0; padding: 0; }

/* ── Page ── */
.rp {
  background: #0f0f0f;
  position: relative;
  overflow: hidden;
}

.rp__content {
  background: transparent !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 56px 16px 36px;
  min-height: 100%;
  position: relative;
  z-index: 1;
}

/* ── Background layers ── */
.rp__bg-grid {
  position: fixed;
  inset: 0;
  background-image:
    linear-gradient(rgba(201,169,105,0.05) 1px, transparent 1px),
    linear-gradient(90deg, rgba(201,169,105,0.05) 1px, transparent 1px);
  background-size: 44px 44px;
  pointer-events: none;
  z-index: 0;
}

.rp__bg-glow {
  position: fixed;
  top: -140px;
  left: 50%;
  transform: translateX(-50%);
  width: 560px;
  height: 560px;
  background: radial-gradient(ellipse at center, rgba(201,169,105,0.13) 0%, transparent 62%);
  pointer-events: none;
  z-index: 0;
}

.rp__bg-glow2 {
  position: fixed;
  bottom: -100px;
  right: -80px;
  width: 320px;
  height: 320px;
  background: radial-gradient(ellipse at center, rgba(201,169,105,0.05) 0%, transparent 65%);
  pointer-events: none;
  z-index: 0;
}

/* ── Back button ── */
.rp__back {
  position: fixed;
  top: 14px;
  left: 14px;
  z-index: 100;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(201,169,105,0.10);
  border: 1px solid rgba(201,169,105,0.18);
  color: #C9A969;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  transition: background 0.18s;
}

.rp__back:active { background: rgba(201,169,105,0.20); }

/* ── Header ── */
.rp__header {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 440px;
  margin-bottom: 24px;
  position: relative;
}

.rp__logo-halo {
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  width: 140px;
  height: 60px;
  background: radial-gradient(ellipse at center, rgba(201,169,105,0.22) 0%, transparent 70%);
  pointer-events: none;
  z-index: 0;
}

.rp__logo {
  position: relative;
  z-index: 1;
  width: 150px;
  height: 150px;
  object-fit: contain;
  margin-bottom: 12px;
  filter:
    drop-shadow(0 0 16px rgba(201,169,105,0.35))
    drop-shadow(0 4px 12px rgba(0,0,0,0.5));
}

.rp__brand-rule {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 160px;
  margin-bottom: 8px;
}

.rp__brand-rule span:not(.rp__brand-diamond) {
  flex: 1;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(201,169,105,0.5), transparent);
}

.rp__brand-diamond { font-size: 6px; color: #C9A969; opacity: 0.7; }

.rp__brand-tag {
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 2.8px;
  color: rgba(201,169,105,0.6);
  text-transform: uppercase;
}

/* ── Card ── */
.rp__card {
  width: 100%;
  max-width: 440px;
  background: linear-gradient(160deg, #1c1c1c 0%, #161616 100%);
  border: 1px solid rgba(201,169,105,0.16);
  border-radius: 20px;
  box-shadow:
    0 0 0 1px rgba(255,255,255,0.03),
    0 8px 32px rgba(0,0,0,0.5),
    0 32px 80px rgba(0,0,0,0.5),
    0 0 80px rgba(201,169,105,0.04);
}

.rp__card-accent {
  height: 2px;
  border-radius: 20px 20px 0 0;
  background: linear-gradient(90deg,
    transparent 0%,
    rgba(201,169,105,0.3) 15%,
    #C9A969 35%,
    #e8d08a 50%,
    #C9A969 65%,
    rgba(201,169,105,0.3) 85%,
    transparent 100%);
}

.rp__card-body { padding: 24px 20px 28px; }

.rp__card-heading {
  margin-bottom: 22px;
  padding-bottom: 18px;
  border-bottom: 1px solid rgba(255,255,255,0.05);
}

/* ── Typography ── */
.rp__title {
  font-size: 20px;
  font-weight: 800;
  letter-spacing: -0.3px;
  margin-bottom: 5px;
  background: linear-gradient(135deg, #ffffff 0%, #e8d4a8 60%, #C9A969 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.rp__subtitle { color: rgba(255,255,255,0.30); font-size: 12px; }

/* ── Fields ── */
.rp__field { margin-bottom: 10px; }

.rp__label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  color: rgba(255,255,255,0.38);
  margin-bottom: 7px;
}

/* ── Two-column row ── */
.rp__row-2col {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

/* ── intl-tel-input scoped styles ── */
.lp .iti { width: 100%; display: block; }

.lp .iti__selected-flag {
  background: transparent !important;
  height: 52px;
  padding: 0 10px 0 12px;
  border-right: 1px solid rgba(201,169,105,0.12);
  border-radius: 12px 0 0 12px;
}

.lp .iti__selected-flag:hover,
.lp .iti__selected-flag:focus {
  background: rgba(201,169,105,0.05) !important;
}

.lp .iti__arrow {
  border-top-color: rgba(201,169,105,0.50);
  margin-left: 5px;
}

.lp .iti__arrow--up {
  border-bottom-color: rgba(201,169,105,0.50);
  border-top: none;
}

.lp .iti--separate-dial-code .iti__selected-dial-code,
.lp .iti--show-selected-dial-code .iti__selected-dial-code {
  color: #FFFFFF;
  font-size: 13px;
  margin-left: 5px;
}

/* ── iti dropdown (body-level) ── */
.iti__country-list {
  background: #161616 !important;
  border: 1px solid rgba(201,169,105,0.22) !important;
  border-radius: 12px !important;
  box-shadow: 0 16px 48px rgba(0,0,0,0.85) !important;
  color: #ffffff !important;
  max-height: 260px !important;
  overflow-y: auto !important;
  z-index: 99999 !important;
  margin-top: 4px !important;
}
/* Inline dropdown spans full input width; body-level (.iti--container) unaffected */
.iti > .iti__country-list {
  left: 0 !important;
  right: 0 !important;
  width: 100% !important;
}

.iti-mobile .iti--container {
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
  position: fixed !important;
  z-index: 9999 !important;
  width: 90% !important;
}

.iti__country { padding: 9px 14px !important; }

.iti__country-name {
  color: rgba(255,255,255,0.82) !important;
  font-size: 13px !important;
}

.iti__dial-code {
  color: rgba(201,169,105,0.65) !important;
  font-size: 12px !important;
}

.iti__country.iti__highlight,
.iti__country:hover {
  background: rgba(201,169,105,0.09) !important;
}

.iti__divider {
  border-bottom-color: rgba(201,169,105,0.10) !important;
  margin: 4px 0 !important;
}

.iti__search-input {
  background: #1e1e1e !important;
  border: 1px solid rgba(201,169,105,0.18) !important;
  border-radius: 8px !important;
  color: #ffffff !important;
  font-size: 13px !important;
  margin: 7px !important;
  padding: 8px 12px !important;
  width: calc(100% - 14px) !important;
  box-sizing: border-box !important;
  outline: none !important;
}

.iti__search-input::placeholder { color: rgba(255,255,255,0.25) !important; }

.lp .lp__iti-input {
  height: 52px;
  background: transparent;
  border: none;
  color: #ffffff;
  font-size: 15px;
  outline: none;
  -webkit-user-select: text;
  user-select: text;
}

/* ── Input row (text/email/etc.) ── */
.rp__input-row {
  display: flex;
  align-items: center;
  width: 100%;
  background: #111111;
  border: 1px solid rgba(201,169,105,0.16);
  border-radius: 12px;
  transition: border-color 0.2s, box-shadow 0.2s;
  min-height: 50px;
}

.rp__input-row:focus-within {
  border-color: rgba(201,169,105,0.55);
  box-shadow: 0 0 0 3px rgba(201,169,105,0.08), inset 0 1px 0 rgba(201,169,105,0.04);
}

.rp__input {
  flex: 1 1 auto;
  min-width: 0;
  height: 50px;
  background: transparent;
  border: none;
  color: #FFFFFF;
  font-size: 14px;
  padding: 0 14px;
  outline: none;
  -webkit-appearance: none;
  appearance: none;
  -webkit-user-select: text;
  user-select: text;
  width: 100%;
}

.rp__input::placeholder { color: rgba(255,255,255,0.18); }

.rp__input--date::-webkit-calendar-picker-indicator {
  filter: invert(0.5) sepia(1) hue-rotate(5deg) saturate(3);
  opacity: 0.6;
  cursor: pointer;
}

/* ── Phone row ── */
.rp__phone-row {
  background: #111111;
  border: 1px solid rgba(201,169,105,0.16);
  border-radius: 12px;
  transition: border-color 0.2s, box-shadow 0.2s;
  position: relative;
}

.rp__phone-row:focus-within {
  border-color: rgba(201,169,105,0.55);
  box-shadow: 0 0 0 3px rgba(201,169,105,0.08), inset 0 1px 0 rgba(201,169,105,0.04);
}

.rp .iti { width: 100%; display: block; }

.rp .iti__selected-flag {
  background: transparent !important;
  height: 50px;
  padding: 0 10px 0 12px;
  border-right: 1px solid rgba(201,169,105,0.12);
  border-radius: 12px 0 0 12px;
}

.rp .iti__selected-flag:hover,
.rp .iti__selected-flag:focus { background: rgba(201,169,105,0.05) !important; }

.rp .iti__arrow { border-top-color: rgba(201,169,105,0.50); margin-left: 5px; }
.rp .iti__arrow--up { border-bottom-color: rgba(201,169,105,0.50); border-top: none; }

.rp .iti--separate-dial-code .iti__selected-dial-code,
.rp .iti--show-selected-dial-code .iti__selected-dial-code {
  color: #FFFFFF;
  font-size: 13px;
  margin-left: 5px;
}

.rp .rp__iti-input {
  height: 50px;
  background: transparent;
  border: none;
  color: #ffffff;
  font-size: 14px;
  outline: none;
  -webkit-user-select: text;
  user-select: text;
  padding: 0;
  width: auto;
  flex: 1 1 auto;
  min-width: 0;
}

/* ── Select row ── */
.rp__select-row {
  position: relative;
  background: #111111;
  border: 1px solid rgba(201,169,105,0.16);
  border-radius: 12px;
  transition: border-color 0.2s, box-shadow 0.2s;
  display: flex;
  align-items: center;
  min-height: 50px;
}

.rp__select-row:focus-within {
  border-color: rgba(201,169,105,0.55);
  box-shadow: 0 0 0 3px rgba(201,169,105,0.08);
}

.rp__select {
  flex: 1;
  height: 50px;
  background: transparent;
  border: none;
  color: #FFFFFF;
  font-size: 14px;
  padding: 0 36px 0 14px;
  outline: none;
  -webkit-appearance: none;
  appearance: none;
  cursor: pointer;
  width: 100%;
}

.rp__select option { background: #1e1e1e; color: #fff; }

.rp__select-arrow {
  position: absolute;
  right: 12px;
  pointer-events: none;
  flex-shrink: 0;
}

/* ── Password ── */
.rp__password-input {
  flex: 1 1 auto;
  min-width: 0;
  height: 50px;
  background: transparent;
  border: none;
  color: #FFFFFF;
  font-size: 14px;
  outline: none;
  -webkit-appearance: none;
  appearance: none;
  -webkit-user-select: text;
  user-select: text;
  width: 100%;
}

.rp__password-input::placeholder { color: rgba(255,255,255,0.18); }

.rp__eye-btn {
  color: rgba(201,169,105,0.45);
  transition: color 0.15s;
}

.rp__eye-btn:active { color: #C9A969; }
.rp__eye-btn .f7-icons { font-size: 16px; }

.rp__loc-btn {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  color: rgba(201,169,105,0.55);
  cursor: pointer;
  padding: 0;
  transition: color 0.15s;
}
.rp__loc-btn:active { color: #C9A969; }
.rp__loc-btn:disabled { color: rgba(201,169,105,0.25); }
@keyframes rp-loc-spin {
  to { transform: rotate(360deg); }
}
.rp__loc-spin {
  animation: rp-loc-spin 0.8s linear infinite;
}

/* ── Primary Button ── */
@keyframes rp-shimmer {
  0%   { transform: translateX(-100%) skewX(-20deg); }
  100% { transform: translateX(220%) skewX(-20deg); }
}

.rp__btn-primary {
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  height: 52px;
  margin-top: 6px;
  border-radius: 12px;
  background: linear-gradient(135deg, #d4a84b 0%, #C9A969 40%, #a8853e 100%);
  color: #0f0f0f;
  font-size: 13px;
  font-weight: 900;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  border: none;
  cursor: pointer;
  text-decoration: none;
  box-shadow:
    inset 0 1px 0 rgba(255,255,255,0.20),
    inset 0 -1px 0 rgba(0,0,0,0.15),
    0 4px 16px rgba(201,169,105,0.30),
    0 8px 32px rgba(201,169,105,0.15);
  transition: transform 0.15s;
}

.rp__btn-primary::before {
  content: '';
  position: absolute;
  top: 0; left: 0;
  width: 45%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.22), transparent);
  animation: rp-shimmer 2.8s ease-in-out infinite;
  pointer-events: none;
}

.rp__btn-primary::after {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(255,255,255,0.10) 0%, transparent 50%);
  pointer-events: none;
}

.rp__btn-primary:active { transform: scale(0.982); }

/* ── Secondary Button ── */
.rp__btn-secondary {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 48px;
  border-radius: 12px;
  background: transparent;
  border: 1px solid rgba(201,169,105,0.25);
  color: #C9A969;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-decoration: none;
  transition: background 0.18s, border-color 0.18s;
}

.rp__btn-secondary:active {
  background: rgba(201,169,105,0.07);
  border-color: rgba(201,169,105,0.45);
}

/* ── Divider ── */
.rp__divider {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 20px 0 14px;
}

.rp__divider span { flex: 1; height: 1px; background: rgba(255,255,255,0.06); }

.rp__divider p {
  color: rgba(255,255,255,0.20);
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  white-space: nowrap;
  margin: 0;
}

/* ── Legal Footer ── */
.rp__legal {
  margin-top: 24px;
  text-align: center;
  padding: 0 8px;
  width: 100%;
  max-width: 440px;
}

.rp__legal p { font-size: 10.5px; color: rgba(255,255,255,0.38); line-height: 1.65; margin-bottom: 3px; }
.rp__legal a { color: rgba(201,169,105,0.40); text-decoration: none; }
.rp__legal-copy { font-size: 9.5px !important; color: rgba(255,255,255,0.25) !important; }

/* ── Validation error messages ── */
.rp__field.item-input .item-input-error-message {
  position: static !important;
  display: none;
  color: #e74c3c;
  font-size: 11px;
  font-weight: 600;
  margin-top: 5px;
  padding-left: 2px;
  line-height: 1.4;
  width: auto !important;
  left: auto !important;
  right: auto !important;
  top: auto !important;
  bottom: auto !important;
}

.rp__field.item-input.item-input-invalid > .item-input-error-message {
  display: block;
}

.rp__field.item-input.item-input-invalid .rp__input-row,
.rp__field.item-input.item-input-invalid .rp__phone-row {
  border-color: #e74c3c !important;
  box-shadow: 0 0 0 3px rgba(231,76,60,0.10) !important;
}

/* ── Calendar icon inside DOB field ── */
.rp__cal-ico {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  display: flex;
  align-items: center;
  opacity: 0.7;
}

/* ── F7 Calendar Dark/Gold Theme ── */
.calendar-modal {
  background: #141414 !important;
  border-radius: 20px 20px 0 0 !important;
  border-top: 1px solid rgba(201,169,105,0.22) !important;
  border-left: 1px solid rgba(201,169,105,0.10) !important;
  border-right: 1px solid rgba(201,169,105,0.10) !important;
}
/* Toolbar (month/year nav) */
.calendar-modal .toolbar {
  background: #1c1c1c !important;
  border-bottom: 1px solid rgba(201,169,105,0.14) !important;
}
.calendar-modal .toolbar .toolbar-inner { padding: 0 8px; }
.calendar-modal .toolbar a.link,
.calendar-modal .toolbar .link {
  color: #C9A969 !important;
  font-size: 14px;
  font-weight: 700;
}
/* Month / year label in toolbar */
.calendar-modal .calendar-month-year,
.calendar-modal .calendar-header {
  color: #ffffff !important;
  font-size: 15px !important;
  font-weight: 700 !important;
}
.calendar-modal .calendar-month-year span { color: #ffffff !important; }
/* Prev / Next arrows */
.calendar-modal .calendar-prev-month-button i,
.calendar-modal .calendar-next-month-button i,
.calendar-modal .calendar-prev-year-button i,
.calendar-modal .calendar-next-year-button i {
  color: #C9A969 !important;
}

/* Body background */
.calendar-modal .calendar-modal-inner,
.calendar-modal .sheet-modal-inner {
  background: #141414 !important;
}

/* Weekday header row */
.calendar-modal .calendar-day-of-week span,
.calendar-modal .calendar-week-header span {
  color: rgba(201,169,105,0.60) !important;
  font-size: 11px !important;
  font-weight: 700 !important;
}
.calendar-modal .calendar-week-days span {
  color: rgba(201,169,105,0.60) !important;
  font-weight: 700 !important;
}

/* Day cells */
.calendar-modal .calendar-day-number {
  color: rgba(255,255,255,0.80) !important;
  border-radius: 50% !important;
  width: 34px !important;
  height: 34px !important;
  line-height: 34px !important;
}
.calendar-modal .calendar-day:not(.calendar-day-selected):not(.calendar-day-disabled):not(.calendar-day-prev-month):not(.calendar-day-next-month):active .calendar-day-number,
.calendar-modal .calendar-day:not(.calendar-day-selected):not(.calendar-day-disabled):not(.calendar-day-prev-month):not(.calendar-day-next-month):hover .calendar-day-number {
  background: rgba(201,169,105,0.16) !important;
  color: #C9A969 !important;
}
/* Today */
.calendar-modal .calendar-day.calendar-day-today .calendar-day-number {
  border: 1.5px solid rgba(201,169,105,0.55) !important;
  color: #C9A969 !important;
  background: transparent !important;
}
/* Selected */
.calendar-modal .calendar-day.calendar-day-selected .calendar-day-number {
  background: linear-gradient(135deg, #d4a84b 0%, #C9A969 50%, #a8853e 100%) !important;
  color: #111111 !important;
  font-weight: 800 !important;
  box-shadow: 0 4px 14px rgba(201,169,105,0.45) !important;
}
.calendar-modal .calendar-day.calendar-day-selected.calendar-day-today .calendar-day-number {
  border: none !important;
}
/* Disabled / other month */
.calendar-modal .calendar-day.calendar-day-disabled .calendar-day-number,
.calendar-modal .calendar-day.calendar-day-prev-month .calendar-day-number,
.calendar-modal .calendar-day.calendar-day-next-month .calendar-day-number {
  color: rgba(255,255,255,0.18) !important;
}

/* Month / Year scroll picker (shows when tapping month-year label) */
.calendar-modal .calendar-month-picker,
.calendar-modal .calendar-year-picker {
  background: #141414 !important;
}
.calendar-modal .calendar-picker-item,
.calendar-modal .picker-column-item {
  color: rgba(255,255,255,0.35) !important;
}
.calendar-modal .calendar-picker-item.active-item,
.calendar-modal .calendar-picker-item.picker-item-selected,
.calendar-modal .picker-column-item.picker-item-selected {
  color: #C9A969 !important;
  font-weight: 700 !important;
}
`,
  styleScoped: false
};